import { useTranslation } from "react-i18next";
import type { VersionLabel } from "../../../api/content/versionDecoders";
import { classNames } from "../../../ui/styles/classNames";
import { versionLabelText } from "./versionText";

/**
 * One version by name: "Extract claims 1.2.0", its change line as secondary text. `name`
 * `null` names the project content as a whole. A version without a label shows
 * `unlabelled` where its name alone says enough, else that it has no label.
 */
export default function VersionLabelText({ name, label, unlabelled = null, className }: { name: string | null; label: VersionLabel | null; unlabelled?: string | null; className?: string }) {
  const { t } = useTranslation();
  if (label === null) {
    return <span className={classNames(unlabelled === null && "app-text-muted", className)}>{unlabelled ?? t("versions.unlabelled")}</span>;
  }
  return (
    <span className={className}>
      <span>{versionLabelText(t, name, label.version)}</span>
      {label.changeLine === "" ? null : <span className="app-text-muted"> · {label.changeLine}</span>}
    </span>
  );
}
